export default class RewardsController {
  constructor(resource) {
    this._resource = resource;
  }

  getAllRewards() {
    return this._resource(`rewards`)
            .get()
            .then(res => res.body)
            .catch(error => { throw error })
  }
}
